var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconsChartTypesBoxPlot = function SvgIconsChartTypesBoxPlot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.727 3c.502 0 .91.403.91.9v2.7a1.81 1.81 0 0 1 1.818 1.8v6.3c0 .994-.814 1.8-1.819 1.8v3.6c0 .497-.407.9-.909.9a.905.905 0 0 1-.909-.9v-3.6A1.81 1.81 0 0 1 2 14.7V8.4c0-.994.814-1.8 1.818-1.8V3.9c0-.497.407-.9.91-.9zm14.546 0c.502 0 .909.403.909.9v1.8A1.81 1.81 0 0 1 22 7.5v6.3c0 .994-.814 1.8-1.818 1.8v4.5c0 .497-.407.9-.91.9a.905.905 0 0 1-.908-.9v-4.5a1.81 1.81 0 0 1-1.819-1.8V7.5c0-.994.814-1.8 1.819-1.8V3.9c0-.497.407-.9.909-.9zM12 3c.502 0 .91.403.91.9v5.4a1.81 1.81 0 0 1 1.817 1.8v6.3c0 .994-.814 1.8-1.818 1.8v.9c0 .497-.407.9-.909.9a.905.905 0 0 1-.91-.9v-.9a1.81 1.81 0 0 1-1.817-1.8v-6.3c0-.994.814-1.8 1.818-1.8V3.9c0-.497.407-.9.909-.9zm.91 8.1h-1.82v6.3h1.82v-6.3zM5.635 8.4H3.818v6.3h1.818V8.4zm14.546-.9h-1.818v6.3h1.818V7.5z"
  }))));
};
export default SvgIconsChartTypesBoxPlot;